import React, { Component } from 'react';
import { checkPermissionForViewRequest, checkPermissionForFieldRequest } from './redux/actions/check_permission.actions';

export const checkPermissionsHOC = (WrappedComponent, urls, entity) => class extends Component {
    componentDidMount() {
        if (entity === 'fields') {
            this.props.dispatch(checkPermissionForFieldRequest(urls));
        } else {
            this.props.dispatch(checkPermissionForViewRequest(urls));
        }
    }

    render() {
        if (this.props.views_permissions) {
            return <WrappedComponent {...this.props} />;
        } if (this.props.fields_permissions) {
            return <WrappedComponent {...this.props} />;
        }
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/CheckPermissions.js